module.exports = __webpack_public_path__ + "static/media/landing-picture.03a8a601.jpg";